// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"77062a1a","247":"7f9d64db","513":"2e90ded3","625":"84efc53e","706":"cc727622"}[chunkId] + ".chunk.js";
};